<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">回单匹配查询</h1>
        <AdvancedFeatureNotice
          api-url="/api/v2/ebill/queryMatchedRelation"
        />
        <p class="text-gray-600">查询交易流水与回单的匹配关系</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                查询指定条件下的回单匹配结果，返回分页记录列表。
                <br />
                说明：
                <br />- 需携带鉴权请求头 <br />- 两个参数均为必填
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
                <span class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">GET</span>
                <code class="text-sm font-mono">/api/v2/ebill/queryMatchedRelation</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">请求头参数</h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">参数名</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">必需</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">示例值</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-app-id</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">APP ID</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">4d9414e89bc24b0d89b678d9f20bc56a</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-app-secret</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">API Key</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">8201e508ef948b8fcdca855729e7ee34</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">x-customer-code</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">客户编号</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">CUSTFA48DD8EFF437956</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">请求参数</h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">参数名</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">必需</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">示例值</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">accountNo</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">本方账号</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">6228480001000200003</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">accountingDateId</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Number</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">是</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">记账日期ID，格式：yyyyMMdd</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">20251201</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">pageNow</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Number</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">否</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">页码</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">1</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">pageSize</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Number</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">否</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">每页大小</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">20</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">响应参数</h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">字段</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                          <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">说明</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">code</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">响应代码</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.records</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Array</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">匹配结果列表</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="px-3 md:px-6 py-4">
                            <div class="ml-6">
                              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                  <tr>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">字段名</th>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                                  </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                  <tr>
                                    <td class="px-6 py-2 text-sm">uniqueNumber</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">流水唯一编号</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">receiptFileName</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">String</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">回单文件名（可能为空）</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">data.pageable</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Object</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">分页数据对象</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="px-3 md:px-6 py-4">
                            <div class="ml-6">
                              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                  <tr>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">字段名</th>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                                    <th class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">描述</th>
                                  </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                  <tr>
                                    <td class="px-6 py-2 text-sm">exportMaxRows</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">导出最大行数</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">hasNext</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Boolean</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">是否有下一页</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">hasPre</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Boolean</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">是否有上一页</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">isFirst</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Boolean</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">是否是首页</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">isLast</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Boolean</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">是否是最后一页</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">pageNow</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">当前页</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">pageSize</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">每页大小</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">startPos</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">起始位置</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">totalCount</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">总记录数</td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">totalPageCount</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">Number</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">总页数</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">realJsonModel</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">是否真实模型</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">status</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">String</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">HTTP状态</td>
                        </tr>
                        <tr>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">successResponse</td>
                          <td class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500">Boolean</td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">是否成功响应</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>填写参数并查询匹配结果</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">x-app-id <span class="text-red-500">*</span></label>
                    <input
                      v-model="appId"
                      type="text"
                      :class="{'!border-red-500': showValidation && !appId}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">x-app-secret <span class="text-red-500">*</span></label>
                    <input
                      v-model="authorization"
                      type="text"
                      :class="{'!border-red-500': showValidation && !authorization}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">x-customer-code <span class="text-red-500">*</span></label>
                    <input
                      v-model="customerCode"
                      type="text"
                      :class="{'!border-red-500': showValidation && !customerCode}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>

                  <div class="grid grid-cols-1 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">accountNo <span class="text-red-500">*</span></label>
                      <input
                        v-model="accountNo"
                        type="text"
                        placeholder="622848..."
                        :class="{'!border-red-500': showValidation && !accountNo}"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">accountingDateId (yyyyMMdd) <span class="text-red-500">*</span></label>
                      <input
                        v-model="accountingDateId"
                        type="text"
                        placeholder="20251201"
                        :class="{'!border-red-500': showValidation && !accountingDateId}"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">pageNow</label>
                    <input
                      v-model="pageNow"
                      type="text"
                      placeholder="1"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">pageSize</label>
                    <input
                      v-model="pageSize"
                      type="text"
                      placeholder="20"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <button
                    @click="queryMatchRecords"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "查询中..." : "发送请求" }}
                  </button>
                </div>
              </div>

              <div v-if="response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"><code class="language-json">{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import AdvancedFeatureNotice from "./ui/AdvancedFeatureNotice.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";

const highlightCode = () => {
  nextTick(() => {
    setTimeout(() => {
      const allCodeBlocks = document.querySelectorAll("pre code");
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };
      const langClass = languageMap[activeLanguage.value];
      allCodeBlocks.forEach((block) => {
        const el = block as HTMLElement;
        el.className = "";
        el.removeAttribute("data-highlighted");
        el.classList.add("hljs");
        if (langClass) el.classList.add(langClass);
        try {
          hljs.highlightElement(el);
        } catch {}
      });
    }, 100);
  });
};

useCodeHighlight("pre code");
onMounted(() => {
  highlightCode();
});

const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const accountNo = ref("");
const accountingDateId = ref("");
const pageNow = ref("");
const pageSize = ref("");

const loading = ref(false);
const showValidation = ref(false);
const activeLanguage = ref("curl");
const response = ref("");

const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");
    if (response) {
      return { appId: response.appId, appSecret: response.appSecret };
    }
    return null;
  } catch {
    return null;
  }
};

const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/customer/listWithSummary", {
      pageNow: 1,
      pageSize: 10,
    });
    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch {
    return null;
  }
};

const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");
  if (userInfoStr) {
    const appInfo = await getApplicationInfo();
    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }
    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

onMounted(() => {
  autoFetchUserInfo();
});

watch([appId, authorization, customerCode, accountNo, accountingDateId, pageNow, pageSize, activeLanguage, response], () => {
  highlightCode();
}, { flush: "post" });

const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

const getRequestText = () => {
  const baseUrl = import.meta.env.VITE_API_URL + "/api/v2/ebill/queryMatchedRelation";
  const params = new URLSearchParams();
  if (accountNo.value) params.append("accountNo", accountNo.value);
  if (accountingDateId.value) params.append("accountingDateId", accountingDateId.value);
  if (pageNow.value) params.append("pageNow", pageNow.value);
  if (pageSize.value) params.append("pageSize", pageSize.value);
  const qs = params.toString() || "accountNo=622848...&accountingDateId=20251201";

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X GET '${baseUrl}?${qs}' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}'`
      );
    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const config = {\n` +
        `  method: 'get',\n` +
        `  url: '${baseUrl}?${qs}',\n` +
        `  headers: {\n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `  }\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    console.log(response.data);\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );
    case "python":
      return (
        `import requests\n\n` +
        `url = "${baseUrl}"\n` +
        `params = {\n` +
        (accountNo.value ? `  'accountNo': '${accountNo.value}',\n` : "") +
        (accountingDateId.value ? `  'accountingDateId': '${accountingDateId.value}'\n` : "") +
        `}\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}'\n` +
        `}\n\n` +
        `r = requests.get(url, headers=headers, params=params)\n` +
        `print(r.json())`
      );
    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `HttpUrl url = HttpUrl.parse("${baseUrl}").newBuilder()\n` +
        (accountNo.value ? `  .addQueryParameter("accountNo", "${accountNo.value}")\n` : "") +
        (accountingDateId.value ? `  .addQueryParameter("accountingDateId", "${accountingDateId.value}")\n` : "") +
        `  .build();\n` +
        `Request request = new Request.Builder()\n` +
        `  .url(url)\n` +
        `  .get()\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();\n` +
        `System.out.println(response.body().string());`
      );
    case "csharp":
      return (
        `var client = new RestClient("${baseUrl}?${qs}");\n` +
        `var request = new RestRequest(Method.GET);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("x-customer-code", "${customerCode.value}");\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `Console.WriteLine(response.Content);`
      );
    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${baseUrl}?${qs}',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'GET',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n` +
        `curl_close($curl);\n` +
        `echo $response;`
      );
    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n` +
        `require "openssl"\n\n` +
        `url = URI("${baseUrl}?${qs}")\n` +
        `https = Net::HTTP.new(url.host, url.port)\n` +
        `https.use_ssl = true\n` +
        `request = Net::HTTP::Get.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n` +
        `response = https.request(request)\n` +
        `puts response.body`
      );
    default:
      return "";
  }
};

const queryMatchRecords = async () => {
  console.log("点击发送请求");
  showValidation.value = true;
  if (!appId.value || !authorization.value || !customerCode.value) {
    console.log("鉴权参数缺失");
    alert("请等待自动获取鉴权参数或手动填写");
    return;
  }
  if (!accountNo.value || !accountingDateId.value) {
    console.log("必填参数缺失");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const serverUrl = import.meta.env.VITE_API_URL || "";
    
    // 构建查询参数
    const queryParams = new URLSearchParams();
    if (accountNo.value) queryParams.append("accountNo", accountNo.value);
    if (accountingDateId.value) queryParams.append("accountingDateId", accountingDateId.value);
    if (pageNow.value) queryParams.append("pageNow", pageNow.value);
    if (pageSize.value) queryParams.append("pageSize", pageSize.value);
    
    const queryString = queryParams.toString();
    const url = `${serverUrl}/api/v2/ebill/queryMatchedRelation${queryString ? '?' + queryString : ''}`;
    console.log("Request URL:", url);

    // 使用 fetch 替代 httpService 以避免 Pragma 头导致的跨域问题
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
    });

    console.log("Response Status:", res.status);
    
    if (!res.ok) {
       throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    console.log("Response Data:", data);
    response.value = JSON.stringify(data, null, 2);
    showValidation.value = false;
  } catch (error) {
    console.error("查询出错:", error);
    alert("查询失败，请稍后重试或检查参数与权限");
  } finally {
    loading.value = false;
  }
};
</script>

